let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("adoSC")).then(() => parcelRequire('cUG5u'));